import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron",
  "use": "icon-chevron-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" fill=\"none\" id=\"icon-chevron\">\n  <path d=\"M14.9614 10.7322L13.9273 11.7663L9.94435 7.78338L5.96143 11.7663L4.92728 10.7322L9.94435 5.71509L14.9614 10.7322Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol